import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTO_RECEIVED_STATUS } from 'domains/merchant-inventory-batch/constants/merchant-inventory-batch-item-constants'

const propTypes = {
  photo_received_status: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Inventory Batch `photo_studio_receive_status`.
 * It maps `photo_studio_status` to certain style and pass to `StatusBadge`.
 * @param {string} photo_studio_receive Merchant Inbound Inventory Batch.
 */
const MerchantInventoryBatchItemPhotoStudioReceiveBadge = ({ photo_received_status }) => {

  const colorMap = {
    [PHOTO_RECEIVED_STATUS.PENDING]   : 'warning',
    [PHOTO_RECEIVED_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[photo_received_status]

  return <StatusBadge color={ color } label={ photo_received_status } />
}

MerchantInventoryBatchItemPhotoStudioReceiveBadge.propTypes = propTypes

export default MerchantInventoryBatchItemPhotoStudioReceiveBadge
